import React, { useState } from 'react';
import Button from '../Button';

interface MobileMenuSectionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

/**
 * Expandable section in the mobile menu. Dropdown items are shown as sub-sections.
 */
export default function MobileMenuSection({
  title,
  children,
  defaultOpen = false,
}: MobileMenuSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="mobile-menu-section border-bottom">
      <Button
        type="button"
        className="d-flex align-items-center justify-content-between w-100 py-3 px-0 btn btn-link text-dark text-start text-decoration-none border-0 bg-transparent"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ fontWeight: 600 }}
      >
        {title}
        <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'} text-muted small`} />
      </Button>
      {isOpen && (
        <div className="mobile-menu-section-content pb-2 ps-3">
          {children}
        </div>
      )}
    </div>
  );
}
